import React from 'react'

const Register = () => {
  return (
    <div className='bg-gradient-to-r from-fthColor to-primeColor text-center rounded-sm shadow-md'>
        <button className='text-xs py-2 px-8'>Register</button>
    </div>
  )
}

export default Register